import Card from "../templates/card.js";

const capInfiniteHits = instantsearch.connectors.connectInfiniteHits(
	(renderOptions, isFirstRender) => {
		const { hits,
			widgetParams,
			showPrevious,
			isFirstPage,
			showMore,
			isLastPage, } = renderOptions;

		if ( isFirstRender ) {
			const button = document.querySelector('.stream1-more a');
			button.addEventListener('click', () => {
				showMore();
			});
		}
		
		if ( isLastPage ) {
			document.querySelector('.stream1-more').classList.add('is-hidden');
		} else {
			document.querySelector('.stream1-more').classList.remove('is-hidden');
		}

		document.querySelector('#algolia-hits').innerHTML = 
			hits.map(hit => 
				Card( hit )
				).join('');
		;
	}
);
export default capInfiniteHits;